import React from 'react';
import { AlertDialog, Button, TextField, Select } from '@radix-ui/themes';
import { DISCOUNT_CODES } from '../utils/constants';

const ConfirmPaymentDialog = ({
    showConfirmPaymentDialog,
    setShowConfirmPaymentDialog,
    discountCode,
    setDiscountCode,
    isLoading,
    applyDiscountCode,
    handleConfirmPaymentOpenChange,
    selectedDuration,
    setSelectedDuration,
    baseAmount = 4000
}) => {
    const totalAmount = discountCode && discountCode !== 'SHOW'
        ? Math.round(baseAmount * selectedDuration * (1 - (DISCOUNT_CODES[discountCode.toUpperCase()] || 0) / 100)) / 100
        : (baseAmount * selectedDuration) / 100; // Convert pesewas to GHC for display

    return (
        <AlertDialog.Root open={showConfirmPaymentDialog} onOpenChange={handleConfirmPaymentOpenChange}>
            <AlertDialog.Content className="p-6 rounded shadow-lg w-1/3 mx-auto relative">
                <button
                    className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
                    onClick={() => setShowConfirmPaymentDialog(false)}
                    disabled={isLoading}
                    aria-label="Close dialog"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M6 18L18 6M6 6l12 12"
                        />
                    </svg>
                </button>
                <AlertDialog.Title className="mt-2">Upgrade to Advantage Plan</AlertDialog.Title>
                <AlertDialog.Description className="mb-4">
                    Get access to premium features for GHC {totalAmount} for {selectedDuration} {selectedDuration === 1 ? 'month' : 'months'}
                </AlertDialog.Description>
                <div className="mb-6">
                    <ul className="list-disc pl-5 space-y-2 text-gray-600">
                        <li>All Subjects Access</li>
                        <li>50 Questions Daily</li>
                        <li>Priority Support</li>
                        <li>Enhanced Experience</li>
                    </ul>
                </div>
                <div className="mb-6">
                    <label className="block text-gray-700 mb-2">Select Duration</label>
                    <Select.Root
                        value={selectedDuration.toString()}
                        onValueChange={(value) => setSelectedDuration(parseInt(value))}
                        disabled={isLoading}
                    >
                        <Select.Trigger className="w-full" />
                        <Select.Content>
                            <Select.Item value="1">1 Month</Select.Item>
                            <Select.Item value="3">3 Months</Select.Item>
                            <Select.Item value="6">6 Months</Select.Item>
                            <Select.Item value="12">12 Months</Select.Item>
                        </Select.Content>
                    </Select.Root>
                </div>
                <div className="mb-6">
                    <button
                        className="text-blue-600 hover:underline mb-2"
                        onClick={() => setDiscountCode(discountCode ? '' : 'SHOW')}
                        disabled={isLoading}
                    >
                        {discountCode === '' ? 'I have a discount code' : 'Hide discount code'}
                    </button>
                    {discountCode !== '' && (
                        <TextField.Root
                            placeholder="Enter discount code"
                            value={discountCode === 'SHOW' ? '' : discountCode}
                            onChange={(e) => setDiscountCode(e.target.value)}
                            onKeyDown={(e) => e.stopPropagation()}
                            disabled={isLoading}
                            className="mt-2"
                        />
                    )}
                </div>
                <div className="flex justify-end">
                    <Button
                        onClick={applyDiscountCode}
                        className="bg-green-600 text-white px-6 py-2"
                        disabled={isLoading}
                    >
                        {isLoading ? 'Processing...' : 'Make Payment'}
                    </Button>
                </div>
            </AlertDialog.Content>
        </AlertDialog.Root>
    );
};

export default ConfirmPaymentDialog;